// Shares API surface (spec #22).
import { fetchJson, fetchJsonList } from './http';
import type { CreateShareInput, ReportShare, ResolvedShareReport } from './types';

export const sharesApi = {
  async create(getToken: () => string | null, input: CreateShareInput): Promise<ReportShare> {
    return await fetchJson<ReportShare>(`/shares`, getToken, {
      method: 'POST',
      body: input,
    });
  },

  /**
   * List the current user's active shares. The backend wraps the response
   * in `{ data: { items, total, next_cursor } }` (see backend `routes/shares.ts`)
   * so we use `fetchJsonList` to unwrap the array — `fetchJson` alone
   * would hand back the wrapper object and any subsequent `.map()` would crash.
   */
  async list(getToken: () => string | null, limit = 50): Promise<ReportShare[]> {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    const { items } = await fetchJsonList<ReportShare>(`/shares?${params.toString()}`, getToken);
    return items ?? [];
  },

  async revoke(getToken: () => string | null, shareId: string): Promise<void> {
    await fetchJson<unknown>(`/shares/${encodeURIComponent(shareId)}`, getToken, {
      method: 'DELETE',
    });
  },

  async resolve(getToken: () => string | null, reportId: string, token: string) {
    const params = new URLSearchParams();
    params.set('token', token);
    return await fetchJson<ResolvedShareReport>(
      `/shared/reports/${encodeURIComponent(reportId)}?${params.toString()}`,
      getToken,
      { anonymous: true },
    );
  },
};
